<template>
  <dv-border-box-9>
    <h2 class="title">项目总览</h2>
    <div @click="handleFull" class="full_tip_div">
      <title-sub :content="this.isFull ? '退 出' : '全屏显示'"></title-sub>
    </div>
    <div style="width: 600px; height: 200px">
      <div class="info-container">
        <a-row :gutter="24" style="margin-top: 30px">
          <a-col :span="24">
            <div class="info-col-container">
              <span>项目名称</span>
              <a-select @change="onChangePro" class="big_screen_selection" v-model="projectId" style="width: 45%">
                <a-select-option :key="d.id" v-for="d in projectList">{{ d.name }}</a-select-option>
              </a-select>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <div class="info-col-container">
              <span>项目地址</span>
              <span>{{ project.addr }}</span>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <div class="info-col-container">
              <span>项目联系人</span>
              <span>{{ project.person }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="info-col-container">
              <span>联系人电话</span>
              <span>{{ project.personTel }}</span>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div ref="pieChart" style="width: 600px; height: 170px"></div>
  </dv-border-box-9>
</template>

<script>
import { getAction } from '@/api/manage'
import TitleSub from './ScreenTitle/components/TitleSub'
export default {
  components: {
    TitleSub,
  },
  props: ['isFull'],
  data() {
    return {
      pieOptions: {
        color: ['#017FD8'],
        animation: false,
        series: [
          {
            type: 'pie',
            radius: [40, 55],
            center: ['18%', '40%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              color: '#B7E1FF',
              fontSize: '15',
              fontWeight: 'bold',
              formatter: function (params) {
                const formatValue = params.value >= 10000 ? `${(params.value / 10000).toFixed(1)}W` : params.value
                return `${params.name}\n\n ${formatValue}`
              },
            },
            labelLine: {
              show: false,
            },
            data: [{ value: 0, name: '模块总数' }],
          },
          {
            type: 'pie',
            radius: [40, 55],
            center: ['51%', '40%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              color: '#B7E1FF',
              fontSize: '16',
              fontWeight: 'bold',
              formatter: function (params) {
                const formatValue = params.value >= 10000 ? `${(params.value / 10000).toFixed(1)}W` : params.value
                return `${params.name}\n\n ${formatValue}`
              },
            },
            labelLine: {
              show: false,
            },
            data: [{ value: 0, name: '设备总数' }],
          },
          {
            type: 'pie',
            radius: [40, 55],
            center: ['84%', '40%'],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: 'center',
              color: '#B7E1FF',
              fontSize: '15',
              fontWeight: 'bold',
              formatter: function (params) {
                const formatValue = params.value >= 10000 ? `${(params.value / 10000).toFixed(1)}W` : params.value
                return `${params.name}\n\n ${formatValue}`
              },
            },
            labelLine: {
              show: false,
            },
            data: [{ value: 0, name: '数据总数' }],
          },
        ],
      },
      url: {
        projectList: '/project/project/list',
        projectData: '/show/bigScreen/getProjectDataPerson',
      },
      projectId: null,
      project: {
        id: null,
        addr: null,
        person: null,
        personTel: null,
      },
      // 项目列表
      projectList: [],
    }
  },
  async mounted() {
    this.isFulls = this.isFull
    const projects = await this.getprojectList()
    if (projects.result.records && projects.result.records.length > 0) {
      this.projectList = projects.result.records
      // 存在项目默认先取第一个
      this.project = this.projectList[0]
      this.projectId = this.project.id
      this.getChartData()
      this.$emit('projectChange', this.projectId)
    }
  },
  methods: {
    async getChartData() {
      const result = await this.getprojectData()
      const { mkTotal, sbTotal, dataTotal } = result.result
      this.setAllPieData([mkTotal, sbTotal, dataTotal], this.pieOptions)
      // 渲染图表
      const pieChart = this.$echarts.init(this.$refs.pieChart)
      pieChart.setOption(this.pieOptions)
    },
    /**
     * @description: 获取项目数据
     * @param {undefined}
     * @return {Promise}
     */
    async getprojectData() {
      return await getAction(this.url.projectData + '?projectId=' + this.projectId)
    },
    /**
     * 获取项目列表
     */
    async getprojectList() {
      return await getAction(this.url.projectList + '?pageNo=1&pageSize=999')
    },
    /**
     * @description: 设置所有饼图数据
     * @param {list: Array, op: Object}
     * @return {undefined}
     */
    setAllPieData(list, op) {
      list.forEach((value, index) => {
        op.series[index].data[0].value = value
      })
    },
    // 项目改变
    onChangePro(projectId) {
      this.projectId = projectId
      for (let i = 0; i < this.projectList.length; i++) {
        if (projectId == this.projectList[i].id) {
          this.project = this.projectList[i]
          this.getChartData()
          this.$emit('projectChange', projectId)
        }
      }
    },
    // 全屏切换
    handleFull() {
      this.isFull = !this.isFull
      this.$emit('handleFull', this.isFull)
    },
  },
}
</script>
<style lang='less'>
.big_screen_selection {
  background-color: transparent;
  color: #008fee;
  .ant-select-arrow {
    color: #3c7cfa;
    height: 12px;
    width: 12px;
  }
  .ant-select-selection {
    border: 1px solid #3c7cfa;
  }
  .ant-select-selection-selected-value {
    color: #008fee;
  }
}
.title-sub {
  font-size: 20px !important;
  height: 40px !important;
  width: 130px !important;
  line-height: 40px !important;
}
</style>
<style lang='less' scoped>
.info-container {
  margin: 0px 30px 0px 30px;
  .ant-row + .ant-row {
    margin-top: 12px;
  }
}
.info-col-container {
  font-size: 15px;
  color: #008fee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #3c7cfa;
  position: relative;
  padding: 0 6px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #3c7cfa;
    bottom: -2px;
    left: 0;
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #3c7cfa;
    bottom: -2px;
    right: 0;
  }
}
.title {
  text-align: center;
  margin: 0;
  padding-top: 18px;
  color: #96bbda;
  font-size: 24px;
  font-weight: 500;
}
.border-box-content {
  padding: 24px;
}
.full_tip_div {
  position: absolute;
  right: 35px;
  top: 20px;
  cursor: pointer;
}
</style>
